import { IAdminProfile, IAdminProfileResponse } from '@/models/admins.model';

class AdminDataNormalizer implements IAdminProfile {
  firstName;
  email: string;
  id: string;
  lastName: string;
  role: string;
  regionId: string | null;
  regionName: string;
  permissions: string[];

  constructor(profileResponse: IAdminProfileResponse) {
    this.firstName = profileResponse.first_name;
    this.lastName = profileResponse.last_name;
    this.email = profileResponse.email;
    this.role = profileResponse.role;
    this.regionId = profileResponse.region_id ?? null;
    this.regionName = profileResponse.region?.name ?? '';
    this.id = profileResponse.id;
    this.permissions = profileResponse.permissions ?? [];
  }
}

export default AdminDataNormalizer;
